import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { stats, miniTestimonials } from '../../data/content';
export function SocialProof() {
  return <section className="py-12 border-y border-line bg-pistachio-50" data-id="element-244" data-mp="dcfmv284jktm">
      <div className="container mx-auto px-4" data-id="element-245" data-mp="dakwv9hzx2io">
        <div className="flex flex-wrap justify-center gap-8 md:gap-14 mb-12 text-center" data-id="element-246" data-mp="8ee1gan879ez">
          {stats.map(stat => <div key={stat.label} className="flex flex-col items-center" data-id="element-247" data-mp="3g2ss38o34yc">
              <span className="text-3xl font-display font-bold text-pistachio-800 mb-1" data-id="element-248" data-mp="3ukjauqlyuno8">
                {stat.value}
              </span>
              <span className="text-sm text-muted font-medium" data-id="element-249" data-mp="3qjhbm9s1ubm9">{stat.label}</span>
            </div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-250" data-mp="1orufxux7psjg">
          {miniTestimonials.map((t, index) => <motion.div key={t.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-6 rounded-2xl bg-surface border border-line flex flex-col h-full" data-id="element-251" data-mp="1jshvthxq6zkk" data-mpi={index}>
              <div className="flex items-center gap-3 mb-4" data-id="element-252" data-mp="1k9x8f27xlh1m">
                <div className="w-10 h-10 rounded-full bg-pistachio-200 text-pistachio-800 flex items-center justify-center font-bold text-sm" data-id="element-253" data-mp="1p7yr3m1g3eck">
                  {t.initials}
                </div>
                <div className="flex text-pistachio-500" aria-label="5 de 5 estrellas" data-id="element-254" data-mp="2gx1tew9ruemk">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={14} fill="currentColor" aria-hidden="true" data-id="element-255" data-mp="234luo7nwl2rg" data-mpi={i} />)}
                </div>
              </div>
              <p className="text-muted text-sm leading-relaxed mb-4 flex-grow italic" data-id="element-256" data-mp="2vv41njrqzoa5">
                "{t.quote}"
              </p>
              <p className="text-xs text-pistachio-700 font-medium" data-id="element-257" data-mp="30nexaafggnww">— {t.author}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}